import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { Store } from '@ngrx/store';
import { catchError, filter, map, Observable, of, switchMap, take } from 'rxjs';
import { PageUtils } from '../common/page.utils';
import { AssessApiService } from '../services/assess-api.service';
import { LoggingService } from '../services/logging.service';
import { setCampaignContent } from '../store/actions/campaign.actions';
import { AssessmentPageState } from '../store/models/assessment-models';
import { RoutePathParameters } from '../models/assessment-models';
import {selectAssessmentId} from "../store/selectors/assessment.selectors";

@Injectable({
  providedIn: 'root',
})
export class ContentGuardV2 implements CanActivate {
  constructor(
    private readonly assessApiService: AssessApiService,
    private readonly pageUtils: PageUtils,
    private readonly store: Store<AssessmentPageState>,
    private readonly logger: LoggingService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const routeParams: RoutePathParameters = this.pageUtils.getRoutePathParameters(route);

    if (!routeParams.invitationCode) {
      this.logger.logException(new Error('Invitation code missing for campaign content request'), 3);
      return of(false);
    }

    return this.store.select(selectAssessmentId).pipe(
      filter(assessmentId => assessmentId != null && assessmentId > 0),
      take(1),
      switchMap(assessmentId => {
        return this.assessApiService
          .getCampaignContentV2(routeParams.orgCode, routeParams.campaignCode, routeParams.invitationCode, assessmentId)
          .pipe(
            take(1),
            map((response) => {
              this.store.dispatch(setCampaignContent({ content: response.contents }));
              return true;
            }),
            catchError((err: HttpErrorResponse) => {
              this.logger.logException(err, 3);
              console.log('Error retrieving campaign content: \n', err);

              return of(false);
            }),
          )
      })
    );
  }
}
